import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../contexts/CartContext";
import CartItemRow from "./CartItemRow";

const CartDrawer: React.FC = () => {
    const navigate = useNavigate();
    const { items, isOpen, closeDrawer, subtotal, total, hasPhysicalItem } = useCart();

    const goToCheckout = () => {
        closeDrawer();
        navigate("/checkout");
    };

    return (
        <div className={`fixed inset-0 z-50 ${isOpen ? "pointer-events-auto" : "pointer-events-none"}`}>
            <div
                className={`absolute inset-0 bg-black/60 transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
                    }`}
                onClick={closeDrawer}
            />

            <aside
                className={`absolute right-0 top-0 h-full w-full max-w-lg transform border-l border-white/10 bg-midnight-800/95 p-6 shadow-drawer transition-transform duration-300 ${isOpen ? "translate-x-0" : "translate-x-full"
                    }`}
            >
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] text-white/60">Cart</p>
                        <h2 className="text-2xl font-semibold">Modelerman Store</h2>
                    </div>
                    <button onClick={closeDrawer} className="rounded-full bg-white/10 px-3 py-1 text-sm">
                        Close
                    </button>
                </div>

                <div className="mt-6 space-y-4 overflow-y-auto pr-2" style={{ maxHeight: "65vh" }}>
                    {items.length === 0 ? (
                        <div className="rounded-2xl border border-dashed border-white/15 bg-white/5 p-8 text-center text-white/60">
                            Your cart is empty. Explore the Texture Lab or Figur Lab to add something inspiring.
                        </div>
                    ) : (
                        items.map((item) => <CartItemRow key={item.id} item={item} />)
                    )}
                </div>

                <div className="mt-6 space-y-3 rounded-2xl border border-white/10 bg-white/5 p-5">
                    <div className="flex items-center justify-between text-sm text-white/70">
                        <span>Subtotal</span>
                        <span className="font-semibold text-white">${subtotal.toFixed(2)}</span>
                    </div>
                    {hasPhysicalItem && (
                        <p className="text-xs text-white/50">Estimated shipping will be calculated at checkout.</p>
                    )}
                    <div className="flex items-center justify-between text-sm text-white/70">
                        <span>VAT placeholder</span>
                        <span className="text-white/60">Calculated at payment</span>
                    </div>
                    <div className="flex items-center justify-between text-base font-semibold">
                        <span>Total</span>
                        <span>${total.toFixed(2)}</span>
                    </div>
                </div>

                <div className="mt-4 flex flex-col gap-3">
                    <button
                        onClick={closeDrawer}
                        className="rounded-xl border border-white/15 bg-transparent py-3 text-sm font-semibold text-white/80"
                    >
                        Continue shopping
                    </button>
                    <button onClick={goToCheckout} className="rounded-xl bg-accent py-3 text-sm font-semibold text-black">
                        Go to checkout
                    </button>
                </div>
            </aside>
        </div>
    );
};

export default CartDrawer;
